import styled from 'styled-components';

export const DocumentsNavbarContainer = styled.div`
  width: 100%;

  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .layout {
    width: 1240px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding-left: 120px;

    justify-content: space-around;
  }
`;
